import {detect} from 'detect-browser';

export const checkIfSafari = () => {
    const browserInfo = detect();

    return browserInfo?.name === 'safari';
};
